import React, { PureComponent } from "react";
import PropTypes from "prop-types";

/**
 * Input文本输入框
 */
class RmtInput extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            fieldProps: {},
            suffixWidth: 0,
        };
    }

    componentDidMount(){
    }

    componentWillUnmount(){
        // 解决异常组件卸载调用setState
        this.setState = ()=>{}
    }

    static getDerivedStateFromProps(props,state) {
        // 判断props中的属性
        if (props.fieldProps&&state !== props.fieldProps) {
            let newProps = {};
            for (const key in props) {
                if (!Object.hasOwnProperty.call(RmtInput.defaultProps, key)) {
                    newProps[key] = props[key];
                }
            }
            for (const fieldKey in props.fieldProps) {
                if(Array.isArray(props.fieldProps?.extra)&&!props.fieldProps?.extra.includes(fieldKey) ){
                    newProps[fieldKey] = props.fieldProps[fieldKey];
                }
            }
            return {...state,fieldProps:{...newProps}}
        }
        return state
    }

    render() {
        const { style={}, value } = this.props.fieldProps;
        return (
            <>
                <div style={style}>
                    <span style={{color: value === "已备案" ? "#008000" : "#FF1313"}}>{value ? value : "未备案"}</span>
                </div>
            </>
        )
    }
}
export default RmtInput;

RmtInput.propTypes = {
    suffixButton: PropTypes.bool,
    prefixLayout: PropTypes.node,
    suffixLayout: PropTypes.node,
    style: PropTypes.object,
    fieldProps: PropTypes.object,
}

RmtInput.defaultProps = {
    prefixLayout: null,
    suffixButton: false,
    suffixLayout: null,
    style: {},
    fieldProps: {},
}